export default __webpack_public_path__ + "static/media/angle-ruler.4c33524a.svg";